exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".MUI-OVERRIDE-no-box-shadow {\n  box-shadow: none !important; }\n\n.MUI-OVERRIDE-no-border {\n  border: none !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/styles/MUIOverrides.scss
// module id = 355
// module chunks = 0